import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

class TopbarSearch extends Component {
  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }
  /*:: toggleDropdown: () => void */


  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  render() {
    const resultItems = this.props.items || [];
    return /*#__PURE__*/React.createElement(Dropdown, {
      isOpen: this.state.dropdownOpen,
      toggle: this.toggleDropdown,
      className: "app-search d-none d-lg-block"
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      tag: "a",
      className: "d-none"
    }), /*#__PURE__*/React.createElement("form", {
      className: "position-relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-group"
    }, /*#__PURE__*/React.createElement("input", {
      className: "form-control dropdown-toggle",
      placeholder: "Search...",
      id: "top-search",
      onClick: this.toggleDropdown
    }), /*#__PURE__*/React.createElement("span", {
      className: "mdi mdi-magnify search-icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "input-group-append"
    }, /*#__PURE__*/React.createElement("button", {
      className: "btn btn-primary",
      type: "submit"
    }, "Search"))), /*#__PURE__*/React.createElement(DropdownMenu, {
      right: true,
      className: "dropdown-menu-animated topbar-dropdown-menu dropdown-lg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dropdown-header noti-title"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "text-overflow mb-2"
    }, "Found ", /*#__PURE__*/React.createElement("span", {
      className: "text-danger"
    }, resultItems.length), " results")), resultItems.map((item, i) => {
      return /*#__PURE__*/React.createElement(Link, {
        key: i,
        to: item.redirectTo,
        className: classNames("dropdown-item", "notify-item")
      }, /*#__PURE__*/React.createElement("i", {
        className: classNames(item.icon, "font-16", "mr-1")
      }), /*#__PURE__*/React.createElement("span", null, item.title));
    }))));
  }

}

export default TopbarSearch;